import { memo, ReactNode } from 'react';

type Props = {
    children: ReactNode;
}

export const ModalFooter = memo(({ children }: Props) => (
    <div className="vss-modal-footer">
        {children}
    </div>
));
